<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eEAg3i/tc-custom/9780830863822.jpg?1696025163762" alt="This image is the cover for the book Excellence in Preaching"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Excellence in Preaching
      </h1>
      <p class="bookDescription body article font2">
        <p>Preaching is a dangerously high calling in which mere mortals dare to speak on behalf of God. All too often, well-intentioned preachers preach poorly. But what do <em>good</em> preachers do well? And what can we learn from them? Simon Vibert has studied the work of today's leading preachers with an eye for discerning the dynamics of effective preaching. Each chapter profiles a contemporary preacher and lifts out practical principles for sermons that are biblical, motivational and transformational. World-renowned preachers like Tim Keller, John Piper and Nicky Gumbel display excellence in preaching by</p>  being aware of cultural and philosophical challenges to the gospel inspiring a passion for the glory of God letting the Bible speak with simplicity and freshness teaching with directness, challenge and relevance exposing all of God's Word to all of God's people and much more  <p>Learn from the best. And become the best preacher that you can be.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Simon Vibert
      </h2>
      
      <p class="authorDescription body article"><p>Reverend Dr. Simon Vibert is vice principal and director of the School of Preaching at Wycliffe Hall, Oxford. He previously served as chairman of the Fellowship of Word and Spirit and has two decades of experience in parish ministry. As one of John Stott?s Langham Trainers, Vibert has equipped pastors in Kenya, Tanzania, Zambia, Serbia and Haiti. He studied at Oak Hill College in London, Glasgow University in Scotland and Reformed Theological Seminary in Orlando, Florida, where his thesis was on the preaching of John Piper. He is the author of<em>Lives Jesus Changed</em> and <em>The Diamond Marriage.</em> </p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f90527ee